/** @format */

import React, {useState} from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Paper from '@mui/material/Paper';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function VendorProfileView({ vendorDetails }) {
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        minWidth: "80vw",
        height: '70vh',
      }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example">
          <Tab label="General Details" {...a11yProps(0)} />
          <Tab label="Buissness Details" {...a11yProps(1)} />
          <Tab label="Financial Details" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}>
        <TabPanel value={value} index={0} dir={theme.direction}>
        <Paper elevation={3}>
          <List
            sx={{
              width: "100%",
              maxWidth: "100%",
              bgcolor: "background.paper",
            }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <ListItem>
                  <ListItemText
                    primary="Vendor Id"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.vendorId}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Source Reference"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.sourceReference}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Title"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.title}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Vendor Name"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.vendorName}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Street Number"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.streetNo}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Country"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.country}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="State"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.state}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="City"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.city}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Address Line 1"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.addressLine1}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Address Line 2"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.addressLine2}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Address Line 3"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.addressLine3}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <ListItem>
                  <ListItemText
                    primary="Postal Code"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.postalCode}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="PO BOX Number"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.poBoxNo}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Vendor Email"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.vendorEmail}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Telephone Number 1"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.telephoneNo1}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Telephone Number 2"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.telephoneNo2}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Mobile Number"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.mobileNo}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Fax Number"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.faxNo}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Contact Person Name"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.contactPersonName}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Contact Person Email"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.contactPersonEmail}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Contact Person Number"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.contactPersonNumber}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Contact Person Designation"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.contactPersonDesignation}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Website"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.website}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
                <ListItem>
                  <ListItemText
                    primary="Overseas Office"
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary">
                          {vendorDetails?.overseasOffice}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              </Grid>
            </Grid>
          </List>
          </Paper>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
        <Paper elevation={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <ListItem>
                <ListItemText
                  primary="ISO Certified?"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.isoCert
                          ? "Yes"
                          : "No"}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Type Of Certificate"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.typeOfCert}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Issuing Authority"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.issuingAuthority}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Certificate Validity"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.certValidity}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <ListItem>
                <ListItemText
                  primary="Certification Year"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.certYear}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Type Of Firm"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.typeOfFirm}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Type Of Business"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.typeOfBusiness}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Workshop Address"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorBusinessDetails?.workshopAddress}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
            </Grid>
          </Grid>
          </Paper>
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
        <Paper elevation={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <ListItem>
                <ListItemText
                  primary="Bank Name"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.bankName}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Beneficiary Account Name"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {
                          vendorDetails?.vendorFinDetails
                            ?.beneficiaryAccountName
                        }
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Beneficiary Account Number"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.beneficiaryAccountNum}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Code Type"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.codeType}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Code"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.code}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Acount Number"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.accountNo}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <ListItem>
                <ListItemText
                  primary="Address"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.address}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Annual Turnover"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.annualTurnover}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Currency"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.currency}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Listed In Stock?"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.listedInStock
                          ? "Yes"
                          : "No"}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" sx={{ml: '15px'}}/>
              <ListItem>
                <ListItemText
                  primary="Name Of Stock"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary">
                        {vendorDetails?.vendorFinDetails?.nameOfStock}
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>
            </Grid>
          </Grid>
          </Paper>
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}
